<template>
    <div class="all-trips container" :class="!user ? 'not-logged' : ''">
        <!-- Header Section -->
        <div class="all-trips-header">
            <div class="header-content">
                <button 
                    class="btn btn-default back-button" 
                    @click="goBack"
                >
                    <i class="fa fa-arrow-left" aria-hidden="true"></i>
                    Retour
                </button>
                
                <div class="header-text">
                    <h1 class="page-title">{{ isPassengerMode ? 'Toutes les demandes' : 'Tous les trajets' }}</h1>
                    <p class="page-subtitle">
                        {{ isPassengerMode ? 'Explorez toutes les demandes de covoiturage sur MyEcoCar' : 'Explorez tous les trajets disponibles sur MyEcoCar' }}
                    </p>
                </div>
                
                <!-- SearchBox -->
                <div class="search-wrapper" v-show="!isMobile || lookSearch">
                    <SearchBox
                        :params="searchParams"
                        v-on:trip-search="research"
                        ref="searchBox"
                    ></SearchBox>
                </div>
            </div>
        </div>
        
        <div v-show="!user && isMobile">
            <router-link :to="{ name: 'login' }" class="login_usuario">
                {{ $t('ingresaORegistrate') }}
                <span class="underline">{{ $t('aqui') }}</span>
                {{ $t('paraComenzar') }}
            </router-link>
        </div>
        
        <Loading :data="trips" v-if="showingTrips">
            <div class="trips-list row">                
                <template v-for="(trip, index) in trips">
                    <template
                        v-if="
                            isDonationTime() &&
                            (!user || !user.monthly_donate) &&
                            !shouldHideDonationOnIOSCapacitor(user)
                        "
                    >
                        <!-- solo si el usuario no es donador mensual -->
                        <div
                            class="panel panel-default panel-donar"
                            v-if="
                                (index +
                                    parseFloat(
                                        appConfig.donation.trips_offset
                                    )) %
                                    parseFloat(
                                        appConfig.donation.trips_count
                                    ) ===
                                0
                            "
                        >
                            <div class="panel-body">
                                <button
                                    class="btn btn-success pull-right btn-donar"
                                    @click="onDonate"
                                >
                                    {{ $t('donar') }}
                                </button>
                                <h2>{{ $t('ayudanos') }}</h2>

                                <a
                                    href="/donar"
                                    target="_blank"
                                    v-on:click.prevent="
                                        onOpenLink(
                                            'https://app.myecocar.fr/donar?u=' +
                                                user.id
                                        )
                                    "
                                >
                                    {{ $t('porQueDonar') }}
                                </a>
                            </div>
                        </div>
                    </template>
                    <template v-if="isComplementary(trip, searchParams, index)">
                        <div class="trip-complementary">
                            <h2>{{ $t('resultadosCercanos') }}</h2>
                        </div>
                    </template>
                    <Trip :trip="trip" :user="user"></Trip>
                </template>
            </div>
            
            <div class="row">
                <p
                    class="alert alert-warning"
                    role="alert"
                    :class="isMobile ? 'mobile-alert' : ''"
                    v-if="resultaOfSearch && !alreadySubscribe"
                >
                    <span class="sentence">
                        <strong :class="isMobile ? 'sentence' : ''">
                            {{ $t('podesSubscribirte') }}
                        </strong>
                        <button
                            class="btn btn-primary"
                            v-if="user"
                            @click="subscribeSearch"
                        >
                            {{ $t('crearAlerta') }}
                        </button>
                    </span>
                </p>
            </div>
            
            <div v-if="runningSearch" class="more-trips-loading">
                <img
                    src="https://app.myecocar.fr/static/img/loader.gif"
                    alt=""
                    class="ajax-loader"
                />
                {{ $t('cargandoMasResultados') }}
            </div>
            
            <template #no-data>
                <p
                    class="alert alert-warning"
                    role="alert"
                    :class="isMobile ? 'mobile-alert' : ''"
                >
                    <template v-if="filtered">
                        <span class="sentence">{{ isPassengerMode ? 'Aucune demande de trajet trouvée' : $t('noHayViajes') }}</span>
                        <span class="sentence" v-if="!alreadySubscribe">
                            <strong :class="isMobile ? 'sentence' : ''">
                                {{ $t('subscribirteAViajes') }}
                            </strong>
                            <button
                                class="btn btn-primary"
                                v-if="user"
                                @click="subscribeSearch"
                            >
                                {{ $t('crearAlerta') }}
                            </button>
                        </span>
                    </template>
                    <template v-else>
                        <span class="sentence">{{ isPassengerMode ? 'Aucune demande de trajet trouvée' : $t('noHayViajesCargadosAun') }}</span>
                    </template>
                </p>
            </template>
            
            <template #loading>
                <p class="alert alert-info" role="alert">
                    <img
                        src="https://app.myecocar.fr/static/img/loader.gif"
                        alt=""
                        class="ajax-loader"
                    />
                    {{ $t('cargandoViajes') }}
                </p>
            </template>
        </Loading>

        <footer class="footer-section">
            <div class="footer-container">
                <div class="footer-left">
                    <div class="footer-logo-section">
                        <img src="https://i.imgur.com/z198fac.png" alt="MyEcoCar Logo" class="footer-logo" />
                        <span class="footer-brand-name">MyEcoCar</span>
                    </div>
                    <div class="footer-social-links">
                        <a href="#" class="social-link" title="Facebook">
                            <i class="fa fa-facebook-f"></i>
                        </a>
                        <a href="#" class="social-link" title="Twitter">
                            <i class="fa fa-twitter"></i>
                        </a>
                        <a href="#" class="social-link" title="Instagram">
                            <i class="fa fa-instagram"></i>
                        </a>
                        <a href="#" class="social-link" title="LinkedIn">
                            <i class="fa fa-linkedin"></i>
                        </a>
                    </div>
                </div>

                <div class="footer-center">
                    <div class="footer-column">
                        <h4 class="footer-column-title">Infos</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'cgu' }">CGU</router-link></li>
                            <li><router-link :to="{ name: 'faq' }">FAQ</router-link></li>
                            <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Découvrir</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'about' }">Qui sommes-nous ?</router-link></li>
                            <li><router-link :to="{ name: 'conduct-charter' }">Charte de bonne conduite</router-link></li>
                            <li><router-link :to="{ name: 'map' }">Carte Interactive</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Plus</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'concept' }">Notre Concept</router-link></li>
                            <li><router-link :to="{ name: 'cookies' }">Utilisation des cookies</router-link></li>
                            <li><router-link :to="{ name: 'sitemap' }">Plan du site</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="footer-bottom">
                <p class="footer-copyright">
                    &copy; {{ new Date().getFullYear() }} MyEcoCar. Tous les droits réservés.
                </p>
            </div>
        </footer>
    </div>
</template>

<style>
.app-container.all-trips,
.app-container.all-trips main,
.app-container.all-trips #main {
    min-height: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.all-trips .view-container {
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
}

.app-container.all-trips .footer-component {
    display: none !important;
}
</style>

<style scoped>
.sentence {
    display: block;
    margin-bottom: 0.5em;
}

.mobile-alert .sentence {
    margin-bottom: 1em;
}

.mobile-alert .btn {
    margin: 0 auto;
    display: block;
}

/* === FORCER 3 CARTES PAR LIGNE === */
.trips-list.row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -15px;
    margin-right: -15px;
}

/* Forcer explicitement 3 colonnes sur grand écran */
.trips-list.row > div[class*="col-"] {
    flex: 0 0 33.333333% !important;
    max-width: 33.333333% !important;
    padding-left: 15px;
    padding-right: 15px;
    margin-bottom: 30px;
}

/* 2 colonnes sur tablette */
@media (max-width: 1199px) {
    .trips-list.row > div[class*="col-"] {
        flex: 0 0 50% !important;
        max-width: 50% !important;
    }
}

/* 1 colonne sur mobile */
@media (max-width: 767px) {
    .trips-list.row > div[class*="col-"] {
        flex: 0 0 100% !important;
        max-width: 100% !important;
    }
}
/* === FIN FORCER 3 CARTES PAR LIGNE === */

.all-trips-header {
    background: #f8f9fa;
    padding: 30px 20px;
    margin: -20px -15px 30px -15px;
    border-bottom: 2px solid #e9ecef;
}

.header-content {
    max-width: 1000px;
    margin: 0 auto;
}

.back-button {
    background: white;
    color: #495057;
    border: 1px solid #dee2e6;
    transition: all 0.3s ease;
    font-weight: 500;
    margin-bottom: 20px;
}

.back-button:hover {
    background: #e9ecef;
    color: #212529;
    border-color: #adb5bd;
}

.header-text {
    margin-bottom: 25px;
}

.page-title {
    color: #212529;
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 8px;
    text-align: center;
}

.page-subtitle {
    color: #6c757d;
    font-size: 16px;
    text-align: center;
    margin-bottom: 0;
    font-weight: 400;
}

.search-wrapper {
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    border: 1px solid #e9ecef;
}

/* Améliorer l'espacement des champs de recherche */
.search-wrapper .search-section {
    gap: 15px;
    align-items: flex-start;
}

.search-wrapper .col-md-3,
.search-wrapper .col-md-5,
.search-wrapper .col-md-4 {
    margin-bottom: 15px;
}

/* Améliorer les champs autocomplete */
.search-wrapper .gmap-autocomplete {
    position: relative;
}

/* Améliorer le bouton de recherche */
.search-wrapper .btn-search {
    width: 100%;
    height: auto;
    font-size: 14px;
    font-weight: normal;
    padding: .8em;
    background: #337ab7;
    border-color: #2e6da4;
    transition: all 0.3s ease;
}

.search-wrapper .btn-search:hover {
    background: #286090;
    border-color: #204d74;
}

/* Améliorer la checkbox pays étranger */
.search-wrapper .foreignCountry-select {
    margin-bottom: 20px;
    padding: 0;
}

.search-wrapper .foreignCountry-select_wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

/* Responsive */
@media (max-width: 767px) {
    .search-wrapper {
        padding: 20px 15px;
    }
    
    .search-wrapper .search-section {
        gap: 10px;
    }
}

.more-trips-loading {
    text-align: center;
    padding: 20px;
    font-size: 16px;
    color: #667eea;
}

.ajax-loader {
    width: 32px;
    height: 32px;
    margin-right: 10px;
}

.footer-section {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #ffffff;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    margin-top: 4rem;
    margin-bottom: 0 !important;
    padding: 3rem 1rem 0;
}

.footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 0.8fr 1.2fr;
    gap: 3rem;
    align-items: start;
}

.footer-left {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.footer-logo-section {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.footer-logo {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.footer-brand-name {
    font-family: 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #aef7b9;
}

.footer-social-links {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.social-link {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #aef7b9;
    text-decoration: none;
    transition: all 0.3s ease;
}

.social-link:hover {
    background: rgba(174, 247, 185, 0.2);
    color: #ffffff;
    transform: translateY(-3px);
}

.social-link i {
    font-size: 1.25rem;
}

.footer-center {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem;
}

.footer-column {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.footer-column-title {
    font-family: 'Poppins', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: #aef7b9;
    margin: 0;
}

.footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.footer-links li {
    margin: 0;
}

.footer-links a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.95rem;
    transition: color 0.3s ease;
}

.footer-links a:hover {
    color: #aef7b9;
    text-decoration: underline;
}

.footer-bottom {
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 0;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
    border-top: 1px solid rgba(174, 247, 185, 0.2);
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
}

.footer-copyright {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
}

@media (max-width: 1024px) {
    .footer-container {
        grid-template-columns: 1fr;
        gap: 2rem;
    }

    .footer-center {
        grid-template-columns: repeat(3, 1fr);
        gap: 2rem;
    }
}

@media (max-width: 768px) {
    .footer-section {
        padding: 2rem 1rem 1rem;
        margin-top: 3rem;
    }

    .footer-left {
        gap: 1.5rem;
    }

    .footer-center {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .footer-column {
        gap: 0.75rem;
    }

    .footer-column-title {
        font-size: 1rem;
    }

    .footer-links a {
        font-size: 0.9rem;
    }

    .footer-logo {
        width: 40px;
        height: 40px;
    }

    .footer-brand-name {
        font-size: 1.25rem;
    }
}

@media (max-width: 480px) {
    .footer-section {
        padding: 1.5rem 1rem;
        margin-top: 2rem;
    }

    .footer-logo {
        width: 35px;
        height: 35px;
    }

    .footer-brand-name {
        font-size: 1.1rem;
    }

    .footer-center {
        grid-template-columns: 1fr;
        gap: 1.2rem;
    }

    .footer-column-title {
        font-size: 0.95rem;
    }

    .footer-links a {
        font-size: 0.85rem;
    }
}
</style>

<script>
import Trip from '../sections/Trip.vue';
import SearchBox from '../sections/SearchTrip.vue';
import Loading from '../Loading.vue';
import bus from '../../services/bus-event.js';
import { mapGetters, mapActions } from 'vuex';
import dayjs from '../../dayjs';
import dialogs from '../../services/dialogs.js';
import { Capacitor } from '@capacitor/core';
import {
    shouldHideDonationOnIOSCapacitor
} from '../../services/capacitor.js';

export default {
    name: 'all-trips',
    props: {
        isPassengerMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            lookSearch: false,
            filtered: false,
            runningSearch: false,
            alreadySubscribe: false,
            resultaOfSearch: false
        };
    },
    methods: {
        ...mapActions({
            search: 'trips/tripsSearch',
            refreshTrips: 'trips/refreshList',
            subscribeToSearch: 'subscriptions/create',
            findSubscriptions: 'subscriptions/index',
            setScrollOffset: 'trips/setScrollOffset'
        }),
        goBack() {
            this.$router.push({ name: 'trips' });
        },
        isDonationTime() {
            if (this.appConfig) {
                return (
                    dayjs().date() <
                    parseFloat(this.appConfig.donation.month_days)
                );
            } else {
                return false;
            }
        },
        shouldHideDonationOnIOSCapacitor(user) {
            return shouldHideDonationOnIOSCapacitor(user);
        },
        research(params) {
            this.resultaOfSearch = true;
            this.lookSearch = false;
            this.filtered = true;
            this.readySub = false;
            this.alreadySubscribe = false;
            this.search(params);
            this.findSubscriptions();
        },
        onTripClick() {
            let scrolloffset = window.scrollY;
            this.setScrollOffset(scrolloffset);
        },
        isComplementary(trip, searchParams, index) {
            let isComplementary = false;
            if (searchParams.data && searchParams.data.date) {
                var searchDate = dayjs(searchParams.data.date).toDate();
                var tripDate = dayjs(trip.trip_date).toDate();
                tripDate.setHours(0);
                tripDate.setMinutes(0);
                tripDate.setSeconds(0);
                if (searchDate.getTime() === tripDate.getTime()) {
                    isComplementary = false;
                } else {
                    isComplementary = true;
                }
            }
            return isComplementary;
        },
        onSearchButton() {
            this.lookSearch = true;
            bus.on('backbutton', this.onBackBottom);
        },
        onClearButton() {
            bus.off('backbutton', this.onBackBottom);
            bus.on('scroll-bottom', this.onScrollBottom);
            this.filtered = false;
            this.lookSearch = false;
            this.alreadySubscribe = false;
            this.search({ is_passenger: this.isPassengerMode });
            if (this.$refs.searchBox) {
                this.$refs.searchBox.clear();
            }
        },
        onScrollBottom() {
            if (this.morePages && !this.lookSearch) {
                if (!this.runningSearch) {
                    this.runningSearch = true;
                    let done = () => {
                        this.runningSearch = false;
                    };
                    this.search({ next: true }).then(done, done);
                }
            }
        },
        onBackBottom() {
            bus.off('backbutton', this.onBackBottom);
            this.lookSearch = false;
            this.alreadySubscribe = false;
        },
        onDonate() {
            // Redirection vers la page de donation
            window.open('https://app.myecocar.fr/donar', '_blank');
        },
        onOpenLink(link) {
            window.open(link, '_blank');
        },
        subscribeSearch() {
            let params = this.searchParams.data;
            let data = {};
            if (params.date) {
                data.trip_date = params.date;
            }
            if (params.origin_name) {
                data.from_address = params.origin_name;
                data.from_lat = params.origin_lat;
                data.from_lng = params.origin_lng;
                data.from_radio = params.origin_radio;
                data.from_id = params.origin_id;
                data.from_json_address = [];
            }
            if (params.destination_name) {
                data.to_address = params.destination_name;
                data.to_lat = params.destination_lat;
                data.to_lng = params.destination_lng;
                data.to_radio = params.destination_radio;
                data.to_id = params.destination_id;
                data.to_json_address = [];
            }

            data.is_passenger = params.is_passenger;

            this.subscribeToSearch(data)
                .then(() => {
                    this.alreadySubscribe = true;
                    dialogs.message(this.$t('correctamenteSubscripto'), {
                        duration: 10,
                        estado: 'success'
                    });
                })
                .catch((response) => {
                    console.log(response);
                    if (response.data.errors && response.data.errors.error) {
                        if (
                            response.data.errors.error[0] ===
                            'subscription_exist'
                        ) {
                            dialogs.message(this.$t('yaTienesSubscripcion'), {
                                duration: 10,
                                estado: 'error'
                            });
                        }
                    }
                });
        }
    },
    mounted() {
        // Charger tous les trajets ou demandes au montage
        this.search({ is_passenger: this.isPassengerMode });
        
        // Écouter les événements
        bus.off('search-click', this.onSearchButton);
        bus.on('search-click', this.onSearchButton);
        bus.off('clear-click', this.onClearButton);
        bus.on('clear-click', this.onClearButton);
        bus.off('scroll-bottom', this.onScrollBottom);
        bus.on('scroll-bottom', this.onScrollBottom);
        bus.off('trip-click', this.onTripClick);
        bus.on('trip-click', this.onTripClick);
    },
    beforeDestroy() {
        bus.off('search-click', this.onSearchButton);
        bus.off('clear-click', this.onClearButton);
        bus.off('scroll-bottom', this.onScrollBottom);
        bus.off('backbutton', this.onBackBottom);
    },
    watch: {
        trips: function (oldValue, newValue) {
            if (this.refreshList) {
                this.refreshTrips(false);
                this.lookSearch = false;
                this.resultaOfSearch = false;
                if (this.$refs.searchBox) {
                    this.$refs.searchBox.clear();
                }
            }
        }
    },
    computed: {
        ...mapGetters({
            trips: 'trips/trips',
            morePages: 'trips/tripsMorePage',
            user: 'auth/user',
            searchParams: 'trips/tripsSearchParam',
            isMobile: 'device/isMobile',
            isBrowser: 'device/isBrowser',
            refreshList: 'trips/refreshList',
            subscriptions: 'subscriptions/subscriptions',
            appConfig: 'auth/appConfig',
            scrollPosition: 'trips/scrollOffset'
        }),
        showingTrips() {
            return !this.isMobile || !this.lookSearch;
        }
    },
    components: {
        Trip,
        Loading,
        SearchBox
    }
};
</script>
